import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import IconButton from '@mui/material/IconButton'
import Collapse from '@mui/material/Collapse'
import Button from '@mui/material/Button'
import CloseIcon from '@mui/icons-material/Close'

export default function Alerts() {
    const [open, setOpen] = useState(false)
    const [type, setType] = useState('success')
    const [title, setTitle] = useState('Удачно')
    useEffect(() => {
        window.showAlert = ({
            title,
            type,

        }) => {
            setType(type)
            setTitle(title)
            setOpen(true)
            setTimeout(() => {
                setOpen(false)
            }, 3000)
        }

    }, [])

    return (
        <Box sx={{ width: '100%', position: 'fixed', top: '' }}>
            <Collapse in={open}>
                <Alert
                    severity={type}
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setOpen(false);
                            }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                    sx={{ mb: 2 }}
                >
                    {title}
                </Alert>
            </Collapse>
        </Box>
    )
}
